<template>
  <div class="item-base">
    <user-detail-title
      first-bread="首页管理"
      second-bread="服务项目"
      third-bread="服务项目修改"
      first-url="/user/sign"
      second-url="/user/service_concept"
      title-name="服务项目修改"
    ></user-detail-title>
    <user-detail-base style="height: 81vh;">
      <el-form label-position="left" label-width="100px" v-if="LookData">
        <el-form-item label="大类">
          <el-select v-model="Clist.type" :placeholder="LookData.typeStr">
            <el-option
              v-for="item in Large"
              :key="item.code"
              :label="item.name"
              :value="item.code">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="小类">
          <el-select v-model="Clist.smallType" :placeholder="LookData.smallTypeStr">
            <el-option
              v-for="item in Small"
              :key="item.code"
              :label="item.name"
              :value="item.code">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="主图">
          <el-upload action="/api/photo/uploadFile" :on-success="GetUrlList">
            <el-button slot="trigger" size="small" type="primary">选取图片</el-button>
          </el-upload>
        </el-form-item>
        <el-form-item label="描述">
          <ripeav-text-input v-model="Clist.description" ></ripeav-text-input>
        </el-form-item>
        <el-form-item label="预览">
          <div v-html="Clist.description"></div>
        </el-form-item>
        <el-button @click="handleChange">修改</el-button>
      </el-form>
    </user-detail-base>
  </div>
</template>

<script>
  import UserDetailTitle from "../Common/UserDetailTitle";
  import UserDetailBase from "../Common/UserDetailBase";
  import RipeavTextInput from "@/components/tinymce/RipeavTextInput";
  export default {
    name: "ConceptChange",
    components: {RipeavTextInput, UserDetailBase, UserDetailTitle},
    data(){
      return{
        Large:{},
        Small:{},
        LookData:null,
        Clist: {
          'id':this.$route.params.id,
          'type':null,
          'smallType':null,
          'photoUrl':null,
          'description':null,
        },//表示Add添加的数据
      }
    },
    watch:{
      'Clist.type'(code){
        if(code == 1){
          this.GetSmallFirst()
        }
        if(code == 2){
          this.GetSmallSecond()
        }
        if(code == 3){
          this.GetSmallThird()
        }
      }
    },
    created() {
      this.GetLarge()
      this.GetLookData(this.$route.params.id)
    },
    methods:{
      GetUrlList(file){
        this.Clist.photoUrl=file.data;

      },
      GetLarge(){
        this.$axios.get('/api/serveItem/getTypeList').then(res=>{
          this.Large=res.data.data;

        })
      },
      GetSmallFirst(){
        this.$axios.get('/api/serveItem/getAudioTypeList').then(res=>{
          this.Small=res.data.data;
        })
      },
      GetSmallSecond(){
        this.$axios.get('/api/serveItem/getAcousticTypeList').then(res=>{
          this.Small=res.data.data;
        })
      },
      GetSmallThird(){
        if (this.Clist.type && this.Clist.smallType){
          if(this.Clist.description || this.Clist.photoUrl){
            this.$axios.get('/api/serveItem/getMediaServeTypeList').then(res=>{
              this.Small=res.data.data;
            })
          } else {
            this.$message.warning('请上传图片或填入描述')
          }
        } else {
          this.$message.error('大类和小类都必须选择')
        }

      },
      handleChange(){
        this.$axios.post('/api/serveItem/update',this.Clist).then(res=>{
          // console.log(this.Clist);
          if(res.data.success == true){
            this.Clist= {
              'type':null,
              'smallType':null,
              'photoUrl':null,
              'description':null,
            }//表示Add添加的数据,
            this.$message({
              message:'修改成功',
              type:'success'
            })
          }
        })
      },
      GetLookData(id){
        this.$axios.get('/api/serveItem/getById/'+id).then(res=>{

          this.LookData=res.data.data
        })
      }
    }
  }
</script>

<style scoped>

</style>